var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircuitArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 12,
    xmlSpace: "preserve",
    id: "circuit_arrow_top",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circuit_arrow_top-bezier",
    stroke: "none",
    fill: "rgb(0, 0, 0)",
    d: "M 19,15 L 17.59,13.59 13,18.17 13,2 11,2 11,18.17 6.41,13.58 5,15 12,22 19,15 Z M 19,15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuitArrowTop);
export default __webpack_public_path__ + "static/media/circuit_arrow_top.f2b3711a267e7f5424b9eda0539f3d12.svg";
export { ForwardRef as ReactComponent };